import { IApplicationState } from '../../types/redux';

export const selectConsultantPhone = (state: IApplicationState) => {
  return state.consultantContacts.phone;
};
